<wl-dashboard-membership-activity [hideTasks]="hideTasks" [hideSalesOpps]="hideSalesOpps"></wl-dashboard-membership-activity>

<div style="margin-bottom: 8rem; clear: both" [hidden]="hideEvents"></div>

<wl-dashboard-events [hidden]="hideEvents"></wl-dashboard-events>

<div style="margin-bottom: 8rem; clear: both" [hidden]="hideRevenue"></div>

<wl-dashboard-revenue [hidden]="hideRevenue"></wl-dashboard-revenue>

<div style="margin-bottom: 8rem; clear: both" [hidden]="hideSalesOpps"></div>

<wl-dashboard-sales-opportunities [hidden]="hideSalesOpps"></wl-dashboard-sales-opportunities>

<div #taskDiv style="margin-bottom: 8rem; clear: both" [hidden]="hideTasks"></div>

<wl-dashboard-tasks [hidden]="hideTasks"></wl-dashboard-tasks>
